var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F72C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3983 14.3475C10.6526 14.3475 10.0274 14.9523 10.0274 15.6738C10.0274 16.3952 10.6526 17 11.3983 17C12.1167 17 12.7692 16.3952 12.7363 15.7056C12.7692 14.947 12.1496 14.3475 11.3983 14.3475Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0583 5.03744C10.4058 5.21781 10 5.79074 10 6.48568C10.0329 6.90477 10.0603 7.32916 10.0932 7.74825C10.1864 9.34502 10.2797 10.91 10.3729 12.5067C10.4058 13.0478 10.839 13.4404 11.3983 13.4404C11.9577 13.4404 12.3963 13.0213 12.4238 12.4749C12.4238 12.146 12.4238 11.8436 12.4567 11.5094C12.517 10.4856 12.5828 9.46173 12.6431 8.43788C12.676 7.77477 12.7363 7.11166 12.7692 6.44855C12.7692 6.20982 12.7363 5.99763 12.6431 5.78543C12.3634 5.19128 11.7109 4.8889 11.0583 5.03744Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fbc58a05434b3fcf8d47a91c6ffe5146.svg";
export { ForwardRef as ReactComponent };